"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const react_toastify_1 = require("react-toastify");
const GlobalModal_1 = require("../../common/js/components/GlobalModal");
const LoadingSpinner_1 = __importDefault(require("../../common/js/components/LoadingSpinner"));
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const auth0_1 = require("../../common/js/helper/auth0");
const noop_1 = require("../../common/js/helper/noop");
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const Languages_1 = require("../constants/Languages");
const Routes_1 = __importDefault(require("../constants/Routes"));
const CustomerType_1 = __importDefault(require("../enums/CustomerType"));
const DataLayerEvents_1 = __importDefault(require("../enums/DataLayerEvents"));
const DataLayerLabels_1 = __importDefault(require("../enums/DataLayerLabels"));
const dataLayer_1 = require("../helper/dataLayer");
const locale_1 = require("../helper/locale");
const AdyenPaymentMethodsResponseStore_1 = __importDefault(require("../stores/AdyenPaymentMethodsResponseStore"));
const MassiveCompany_1 = __importDefault(require("../stores/MassiveCompany"));
const Route_1 = __importDefault(require("../stores/Route"));
const ShopwareContext_1 = __importDefault(require("../stores/ShopwareContext"));
const UiStore_1 = __importDefault(require("../stores/UiStore"));
const AnonymousUserNotice_1 = __importDefault(require("./AnonymousUserNotice"));
const Footer_1 = __importDefault(require("./Footer"));
const MainNavigation_1 = __importDefault(require("./MainNavigation"));
const MessageModal_1 = __importDefault(require("./MessageModal"));
const PopoverLoggedIn_1 = __importDefault(require("./PopoverLoggedIn"));
const ResellerModal_1 = __importDefault(require("./ResellerModal"));
const TopBar_1 = __importDefault(require("./TopBar"));
class Root extends react_1.default.Component {
    clearAdyenCheckoutResetReaction = noop_1.noop;
    finishedSetup = false;
    redirectTo = null;
    dataLayerPushed = false;
    internalLoading = true;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            dataLayerPushed: mobx_1.observable,
            internalLoading: mobx_1.observable,
            initialize: mobx_1.action.bound,
        });
    }
    get isDelegatedCustomer() {
        return (null !== AuthorizationStore_1.default.originalCustomerId &&
            AuthorizationStore_1.default.originalCustomerId !== AuthorizationStore_1.default.customerId);
    }
    componentDidMount() {
        this.redirectToLocaleUrl();
        UiStore_1.default.initialize();
        UiStore_1.default.setupLanguage(Route_1.default.localeOfUrl ?? Languages_1.DEFAULT_LANGUAGE);
        this.setup();
    }
    componentDidUpdate(prevProps) {
        this.redirectToLocaleUrl();
        UiStore_1.default.setupLanguage(Route_1.default.localeOfUrl ?? Languages_1.DEFAULT_LANGUAGE);
        if (!this.finishedSetup) {
            return this.setup();
        }
        if (this.props.auth0?.isAuthenticated) {
            this.pushLoggedInEventToDataLayer();
        }
        const prevClaims = (0, auth0_1.getClaims)(prevProps.auth0);
        const claims = (0, auth0_1.getClaims)(this.props.auth0);
        const authenticatedChanged = prevProps.auth0?.isAuthenticated !== this.props.auth0?.isAuthenticated;
        const customerChanged = prevClaims?.customerId !== claims?.customerId;
        if (prevProps.auth0?.isAuthenticated === this.props.auth0?.isAuthenticated &&
            prevProps.auth0?.isLoading === this.props.auth0.isLoading &&
            prevClaims?.customerId === claims?.customerId &&
            // This is how auth0 react determines if the token was updated and provides a new state.
            prevProps.auth0?.user?.updated_at === this.props.auth0.user?.updated_at) {
            return;
        }
        /*
         * In case our authentication state changes or the customer ID changes,
         * various data has to be forcefully refreshed.
         */
        this.initialize(authenticatedChanged || customerChanged);
    }
    componentWillUnmount() {
        this.clearAdyenCheckoutResetReaction();
        this.finishedSetup = false;
    }
    render() {
        if (null === Route_1.default.localeOfUrl || false !== AuthorizationStore_1.default.auth0?.isLoading) {
            return react_1.default.createElement(LoadingSpinner_1.default, { center: true });
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(MainNavigation_1.default, null),
            react_1.default.createElement("div", { className: "znd-root__content" },
                react_1.default.createElement(TopBar_1.default, null),
                (0, react_router_config_1.renderRoutes)(Routes_1.default)),
            this.internalLoading ? null : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(AnonymousUserNotice_1.default, null),
                react_1.default.createElement(PopoverLoggedIn_1.default, null))),
            react_1.default.createElement(Footer_1.default, null)));
    }
    setup() {
        this.initialize(true);
        this.clearAdyenCheckoutResetReaction = (0, mobx_1.reaction)(() => [ShopwareContext_1.default.adyenEnvironment], () => {
            AdyenPaymentMethodsResponseStore_1.default.reset();
        }, {
            fireImmediately: true,
        });
        this.finishedSetup = true;
    }
    initialize(refreshData) {
        this.internalLoading = true;
        AuthorizationStore_1.default.setAuth0(this.props.auth0);
        if (this.props.auth0?.isLoading) {
            return;
        }
        if (!this.props.auth0.isAuthenticated && !!this.props.auth0.error) {
            // @ts-expect-error Error is untyped.
            const message = this.props.auth0.error?.error_description ?? null;
            if (!!message) {
                react_toastify_1.toast.error(message);
            }
        }
        if (refreshData) {
            MassiveCompany_1.default.reset();
            ShopwareContext_1.default.reset();
        }
        // Checkout, Profile, Registration, Reseller
        const companyInitialize = MassiveCompany_1.default.initialize();
        // Shop, Software, Checkout
        const shopwareContextInitialize = ShopwareContext_1.default.initialize();
        /*
         * Other initializations only an authenticated User needs.
         */
        Promise.all([companyInitialize, shopwareContextInitialize]).then(() => {
            if (!AuthorizationStore_1.default.auth0?.isAuthenticated ||
                AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.REGISTRATION_CREATE)) {
                return;
            }
            if (!!ShopwareContext_1.default.contextExtension?.massiveSalesChannelDeactivated) {
                const title = (0, translation_1.t)('modal.sales_channel_deactivated.title', { channel: AuthorizationStore_1.default.channelId });
                const body = (0, translation_1.t)('modal.sales_channel_deactivated.text', { channel: AuthorizationStore_1.default.channelId });
                (0, GlobalModal_1.showModal)({
                    component: MessageModal_1.default,
                    dontCloseOnOverlayClick: true,
                    props: { title, body },
                }).then(() => AuthorizationStore_1.default.auth0?.logout({ returnTo: window.origin }));
            }
            if (!ShopwareContext_1.default.contextExtension?.massiveConsumablesCheckoutDeactivated &&
                !MassiveCompany_1.default.company?.serviceOrganizationMassiveAddressId &&
                CustomerType_1.default.zxx !== AuthorizationStore_1.default.customerType &&
                CustomerType_1.default.reseller !== AuthorizationStore_1.default.customerType &&
                !this.isDelegatedCustomer) {
                (0, GlobalModal_1.showModal)({
                    component: ResellerModal_1.default,
                    isNotCancelable: AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.COMPANY_UPDATE),
                    props: {},
                });
            }
        });
        this.internalLoading = false;
    }
    redirectToLocaleUrl() {
        if (null !== Route_1.default.localeOfUrl) {
            return;
        }
        const path = Route_1.default.location?.pathname ?? '';
        // Avoid potential endless redirects due to multiple state changes.
        if (path === this.redirectTo) {
            return;
        }
        const locale = (0, locale_1.determineLocale)();
        this.redirectTo = `/${locale}${path.replace(/\/$/g, '')}`;
        Route_1.default.history?.replace(this.redirectTo);
    }
    pushLoggedInEventToDataLayer() {
        if (this.dataLayerPushed || null === AuthorizationStore_1.default.user) {
            return;
        }
        (0, dataLayer_1.pushToDataLayer)({
            event: DataLayerEvents_1.default.dlvEventUserLogged,
            [DataLayerLabels_1.default.dlvCustomer]: AuthorizationStore_1.default.customerId ?? null,
            [DataLayerLabels_1.default.dlvContactPerson]: AuthorizationStore_1.default.contactId ?? null,
            [DataLayerLabels_1.default.dlvSalesChannel]: AuthorizationStore_1.default.channelId ?? null,
        });
        this.dataLayerPushed = true;
    }
}
__decorate([
    bind_decorator_1.default
], Root.prototype, "setup", null);
__decorate([
    bind_decorator_1.default
], Root.prototype, "redirectToLocaleUrl", null);
exports.default = (0, auth0_react_1.withAuth0)((0, mobx_react_1.observer)(Root));
